export default __webpack_public_path__ + "static/media/LeelawUI.10bccd6c.ttf";